import { render, staticRenderFns } from "./SidebarElement.vue?vue&type=template&id=4daee491&"
import script from "./SidebarElement.vue?vue&type=script&lang=js&"
export * from "./SidebarElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports